import { ExtractFunctionNames } from "./extract-function-names";

export type OmitFunctionNames<T> = Omit<T, ExtractFunctionNames<T>>;
